import { Injectable } from "@angular/core";
import {
  Http,
  Response,
  RequestOptions,
  Headers,
  Request,
  RequestMethod,
} from "@angular/http";
import "rxjs/add/observable/throw";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import "rxjs/add/operator/toPromise";
import { Observable } from "rxjs/Observable";

@Injectable()
export class HTTPService {
  // apiUrl: string = "http://sso.emqube.net:84/api/"; // local
  // apiUrl: string = "http://localhost:5000/api/"; 
  geoApiUrl: string = "https://api.postalpincode.in/pincode/";
  // apiUrl:  string ="http://test.emqube.com:90/api/api/"; //Emqube UAT
  // apiUrl:string ="https://pms.swansol.net:8080/api/api/"; // Swan UAT
  // apiUrl: string = "https://pms.emqube.net/api/api/"; // production emqube
  apiUrl: string = "https://pms.swansol.net/api/api/"; // production swan
  public HRMSUrl = "http://test.emqube.com:86/login";


  // CentralizedDB
  centralApiUrl = "https://app.emqube.net:81/api";
  centralBaseUrl = "https://app.emqube.net";

  // centralApiUrl = "https://centraldb-eekn.onrender.com/api";
  // centralBaseUrl = "https://centraldb-frontend.onrender.com"; 
  isCentralLogin = false;

  public rowsOnPageSet: number[];
  public pageSize: number;
  public math = Math;

  constructor(private _http: Http) {
    this.pageSize = 25;
    this.rowsOnPageSet = [25, 50, 100];
  }

  ajaxPost(url: string, paramval?: any): Observable<any[]> {
    var now = moment().valueOf().toString();
    localStorage.setItem("setupTime", now);
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("AuthToken", "5852f0c7-4fbf-4062-bc76-1d5e251ba5c1");

    return this._http
      .post(this.apiUrl + url, JSON.stringify(paramval), {
        headers: headers,
      })
      .map((res) => res.json());
  }

  ajaxPostFileList(url: string, data: any[], params: any): Promise<any> {
    var file = data;
    return new Promise((resolve, reject) => {
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.open("POST", this.apiUrl + url, true);

      let formData = new FormData();
      for (var i = 0; i < data.length; i++) {
        formData.append("file[]", data[i]);
      }
      // formData.append("jobId",params.jobId);
      // formData.append("comments",params.comments);
      formData.append("IRId", params.IRId);
      formData.append("FileType", params.FileType);
      var userDetails = JSON.parse(localStorage.getItem("userDetail"));
      if (userDetails != null) {
        xhr.setRequestHeader("AuthToken", userDetails.AuthToken);
      }
      xhr.send(formData);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(<any>JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      };
    });
  }

  ajaxPostFile(url: string, data: any[]): Promise<any> {
    var file = data;

    return new Promise((resolve, reject) => {
      //let xhr: XMLHttpRequest = new XMLHttpRequest();
      let xhr = new XMLHttpRequest();
      xhr.open("POST", this.apiUrl + url, true);

      let formData = new FormData();
      for (var i = 0; i < data.length; i++) {
        formData.append("file[]", data[i]);
        formData.append("TaskId", data[i].TaskId);
      }

      // formData.append("comments",params.comments);

      var userDetails = JSON.parse(localStorage.getItem("userDetail"));
      if (userDetails != null) {
        xhr.setRequestHeader("AuthToken", userDetails.AuthToken);
        // xhr.setRequestHeader('Content-Type', 'application/json');
      }

      xhr.send(formData);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(<any>JSON.parse(xhr.response));
            console.log(xhr.response);
          } else {
            reject(xhr.response);
          }
        }
      };
    });
  }
  ajaxPostBiometric(url: string, formData: FormData): Promise<any> {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', this.apiUrl + url, true);
      xhr.setRequestHeader('AuthToken', '5852f0c7-4fbf-4062-bc76-1d5e251ba5c1');
      xhr.send(formData);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(<any>JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      };
    });
  }

  private handleError(error: any) {
    let errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.log("Error Message: " + errMsg); // log to console instead
    return null;
  }

  //
  ajaxGetIP(): Observable<any[]> {
    var headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    return this._http
      .get("//jsonip.com", {
        headers: headers,
      })
      .map((res) => res.json());
  }

  ajaxGet(url: string, paramval?: any): any {
    var headers = new Headers();
    //headers.append('Content-Type', 'application/json');
    //headers.append('AuthToken','5852f0c7-4fbf-4062-bc76-1d5e251ba5c1');
    return this._http
      .get(this.apiUrl + url, {
        headers: headers,
      })
      .map((res) => res);
  }

  geolocatePincode(paramval?: any): Observable<any[]> {
    var headers = new Headers();

    return this._http
      .post(this.geoApiUrl, JSON.stringify(paramval), {
        headers: headers,
      })
      .map((res) => res.json());
  }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Services/http.service.ts
 **/